import { Icon } from '@acme/assets';

export const OptionsControl = ({
  profileLinkPath,
  onNavigate,
}: {
  profileLinkPath: string;
  onNavigate?: (path: string) => void;
}) => {
  const handleClick = () => {
    if (onNavigate) {
      onNavigate(profileLinkPath);
    } else {
      window.location.href = profileLinkPath;
    }
  };

  return (
    <div onClick={handleClick} className="p-2 cursor-pointer">
      <Icon name="cog-outline" size={24} />
    </div>
  );
};
